import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "../services/Apis";

function PrivateRoute({ children }) {
  const myItem = getCurrentUser();  
  const itemExists = typeof myItem !== 'undefined' && myItem !== null;
  return itemExists ?  children  : <Navigate to="/login" />;
}
// <Navigate to="/login" />
export default PrivateRoute;
